export const ORDER_MAX = Math.pow(2, 31);

export default function calculateAssetOrder(min?: number, max?: number): number {
    const minVal = min ?? -ORDER_MAX;
    const maxVal = max ?? ORDER_MAX;

    return Math.round((minVal + maxVal) / 2);
}
